import { render, staticRenderFns } from "./SwitchLayout.vue?vue&type=template&id=511e025c"
import script from "./SwitchLayout.vue?vue&type=script&lang=js"
export * from "./SwitchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports